import { getGuardNavSections as getConfiguredGuardNavSections } from './guardPortal.mjs'

export function getAdminNavSections() {
  return [
    {
      label: '工作台',
      branchDepth: 'short',
      items: [
        { name: '管理首页', path: '/', icon: 'home', exact: true },
        { name: '功能导航', path: '/nav', icon: 'nav', exact: true }
      ]
    },
    {
      label: '设备管理',
      branchDepth: 'short',
      items: [
        { name: '班牌设备管理', path: '/admin/boards', icon: 'board', excludePaths: ['/admin/boards/config', '/admin/boards/welcome-special', '/admin/boards/exam-special'] },
        { name: '设备统一配置', path: '/admin/boards/config', icon: 'admin' },
        { name: '欢迎管理', path: '/admin/boards/welcome-special', icon: 'board' },
        { name: '考试管理', path: '/admin/boards/exam-special', icon: 'board' },
        { name: '终端日志', path: '/admin/logs', icon: 'admin' }
      ]
    },
    {
      label: '用户管理',
      branchDepth: 'short',
      items: [
        { name: '学生管理', path: '/admin/students', icon: 'student', exact: true },
        { name: '通校生管理', path: '/admin/students/commuters', icon: 'student' },
        { name: '学生人脸管理', path: '/admin/students/face-manage', icon: 'student' },
        { name: '教师管理', path: '/admin/teachers', icon: 'class' },
        { name: '校医管理', path: '/admin/school-doctors', icon: 'medical' },
        { name: '心理老师管理', path: '/admin/psychology-counselors', icon: 'chat' }
      ]
    },
    {
      label: '权限中心',
      branchDepth: 'short',
      items: [
        { name: '管理员中心', path: '/admin/center', icon: 'shield' }
      ]
    },
    {
      label: '班级管理',
      branchDepth: 'short',
      items: [
        { name: '班级管理', path: '/admin/classes', icon: 'class', excludePaths: ['/admin/classes/dingtalk-sync'] },
        { name: '钉钉同步', path: '/admin/classes/dingtalk-sync', icon: 'import' },
        { name: '班级荣誉管理', path: '/admin/class-honors', icon: 'star' },
        { name: '考勤管理', path: '/attendance', icon: 'attendance', excludePaths: ['/attendance/records'] },
        { name: '签到记录', path: '/attendance/records', icon: 'attendance' },
        { name: '出入登记管理', path: '/admin/class-access/records', icon: 'attendance' }
      ]
    },
    {
      label: '请假管理',
      branchDepth: 'short',
      items: [
        { name: '请假审批', path: '/leave', icon: 'leave' },
        { name: '留校管理', path: '/admin/stay-school', icon: 'leave', excludePaths: ['/admin/stay-school/attendance', '/admin/stay-school/attendance-records'] },
        { name: '取物管理', path: '/pickup', icon: 'leave' },
        { name: '留校考勤记录', path: '/admin/stay-school/attendance-records', icon: 'attendance' },
        { name: '留校生考勤', path: '/admin/stay-school/attendance', icon: 'attendance' }
      ]
    },
    {
      label: '德育管理',
      branchDepth: 'long',
      items: [
        { name: '德育记录', path: '/moral/records', icon: 'chart', exact: true, matchPrefixes: ['/moral/records', '/moral/report', '/moral/record', '/moral/student'] },
        { name: '德育评价', path: '/moral/score', icon: 'chart', exact: true },
        { name: '德育评价项目', path: '/config/moral-items', icon: 'star' }
      ]
    },
    {
      label: '家校互通',
      branchDepth: 'short',
      items: [
        { name: '家校沟通', path: '/home-school', icon: 'chat' }
      ]
    },
    {
      label: '教学管理',
      branchDepth: 'short',
      items: [
        { name: '课表管理', path: '/schedule', icon: 'schedule' },
        { name: 'AI问答管理', path: '/ai/chat-sessions', icon: 'chat' }
      ]
    },
    {
      label: '点餐管理',
      branchDepth: 'short',
      items: [
        { name: '菜品管理', path: '/admin/meal/dishes', icon: 'meal', exact: true },
        { name: '菜单管理', path: '/admin/meal/menus', icon: 'meal' },
        { name: '订单管理', path: '/admin/meal/orders', icon: 'order' }
      ]
    },
    {
      label: '通知与内容',
      branchDepth: 'short',
      items: [
        { name: '学校通知', path: '/notices', icon: 'bell' },
        { name: '学校新闻', path: '/news', icon: 'bell' },
        { name: '通知模板', path: '/notice-templates', icon: 'bell' }
      ]
    },
    {
      label: '宿舍管理',
      branchDepth: 'long',
      items: [
        { name: '楼栋与房间', path: '/admin/dorm/buildings', icon: 'dorm', matchPrefixes: ['/admin/dorm/buildings', '/admin/dorm/room'] },
        { name: '宿管员管理', path: '/admin/dorm/managers', icon: 'admin' },
        { name: '住宿分配', path: '/admin/dorm/assignments', icon: 'student' },
        { name: '住宿考勤', path: '/admin/dorm/sign-in', icon: 'punch' },
        { name: '查寝管理', path: '/admin/dorm/inspection', icon: 'check' },
        { name: '考勤与通知配置', path: '/admin/dorm/attendance-config', icon: 'clock' }
      ]
    },
    {
      label: '数据与配置',
      branchDepth: 'long',
      items: [
        { name: '考勤时间配置', path: '/config/attendance-time', icon: 'clock' },
        { name: '学期管理', path: '/config/semesters', icon: 'calendar' },
        { name: '作息方案管理', path: '/config/time-plans', icon: 'clock' },
        { name: '作息时间表', path: '/config/schedule-time', icon: 'calendar' },
        { name: '一卡通卡号同步', path: '/config/campus-card-sync', icon: 'import' },
        { name: 'APIkey管理', path: '/config/api-keys', icon: 'shield' }
      ]
    }
  ].map(section => ({
    ...section,
    items: (section.items || []).filter(item => !String(item?.path || '').startsWith('/admin/meal/'))
  })).filter(section => (section.items || []).length)
}

export function getDormNavSections() {
  return [
    {
      label: '工作台',
      branchDepth: 'short',
      items: [
        { name: '宿管首页', path: '/dorm/dashboard', icon: 'home', exact: true }
      ]
    },
    {
      label: '值班业务',
      branchDepth: 'short',
      items: [
        { name: '德育扣分', path: '/dorm/moral', icon: 'star' },
        { name: '房间查寝', path: '/dorm/inspection', icon: 'check' },
        { name: '负责寝室', path: '/dorm/students', icon: 'dorm' },
        { name: '留校生', path: '/dorm/stay-school', icon: 'leave' }
      ]
    }
  ]
}

export function getStudentCouncilNavSections() {
  return [
    {
      label: '德育管理',
      branchDepth: 'short',
      items: [
        { name: '学生会扣分', path: '/student-union/moral', icon: 'star', exact: true }
      ]
    }
  ]
}

export function getGuardNavSections() {
  return getConfiguredGuardNavSections()
}
